import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@nazka/nazka.mapframe.components'
import { faChevronDown, faLocation } from '@fortawesome/pro-light-svg-icons'

import theme from '@css/theme.style.json'

import {
  getLabResultHoverKey,
  getVisibleLabResultAnalysis,
  setHoveredClusterResultKeys,
  setHoveredItem,
} from '../../lab-results.slice'

import './lab-results-list-item.styl'

function formatDate(value) {
  const date = value ? new Date(value) : null

  return date && !Number.isNaN(date.getTime())
    ? date.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).replace(',', '')
    : '-'
}

function ListResultListItem({ map, result, activeAnalysisTypeIds, activeResultTypes }) {
  const dispatch = useDispatch()
  const hoveredItem = useSelector(state => state.labResults.hoveredItem)
  const hoveredClusterResultKeys = useSelector(state => state.labResults.hoveredClusterResultKeys)
  const [isOpen, setIsOpen] = useState(false)
  const properties = result?.properties || {}
  const allAnalysis = Array.isArray(properties.analysis) ? properties.analysis : []
  const analysis = getVisibleLabResultAnalysis(allAnalysis, activeAnalysisTypeIds, activeResultTypes)
  const resultStatus = analysis.some(item => item.result?.toLowerCase() === 'positive')
  const resultHoverKey = getLabResultHoverKey(result)
  const isHovered = getLabResultHoverKey(hoveredItem) === resultHoverKey
    || hoveredClusterResultKeys.includes(resultHoverKey)

  return (
    <li
      className={`list-result-list-item${isOpen ? ' list-result-list-item--show' : ''}${isHovered ? ' list-result-list-item--hovered' : ''}`}
      onMouseEnter={() => {
        dispatch(setHoveredClusterResultKeys([]))
        dispatch(setHoveredItem(result))
      }}
      onMouseLeave={() => dispatch(setHoveredItem(null))}
    >
      <div className="list-result-list-item__header">
        <p className="list-result-list-item__header__title">
          <span
            className="list-result-list-item__header__title__status"
            style={{ backgroundColor: resultStatus ? theme.color.danger : theme.color.success }}
          />
          <span className="list-result-list-item__header__title__name">
            {properties.nice_name?.toUpperCase() || '-'}
          </span>
        </p>
        <div className="list-result-list-item__header__actions">
          <Button
            icon={faLocation}
            className="list-result-list-item__header__actions__action"
            layout="ghost"
            hover={false}
            onClick={() => {
              const coordinates = result?.geometry?.coordinates
              if (!map || !Array.isArray(coordinates) || coordinates.length < 2) return

              map.flyTo({
                center: coordinates,
                zoom: 14,
                essential: true,
              })
            }}
          />
          <Button
            icon={faChevronDown}
            onClick={() => setIsOpen(!isOpen)}
            className="list-result-list-item__header__actions__action"
            iconProps={{ css: { transform: isOpen ? 'rotate(180deg)' : '' } }}
            layout="ghost"
            hover={false}
          />
        </div>
      </div>
      <div className="list-result-list-item__body">
        <div className="list-result-list-item__body__inner">
          <div className="list-result-list-item__body__item">
            <p>Type:</p>
            <p>{properties.client_type || 'Mosquito'}</p>
          </div>
          <hr />
          <div className="list-result-list-item__body__item">
            <p>Source:</p>
            <p>{properties.source || '-'}</p>
          </div>
          <hr />
          <div className="list-result-list-item__body__item">
            <p>Tests:</p>
            <p>{analysis.length}</p>
          </div>
          <div className="list-result-list-item__body__item">
            <div className="list-result-list-item__body__item__samples">
              {analysis.map((analysisResult, index) => (
                <div
                  key={`${analysisResult.name || analysisResult.type || 'analysis'}-${index}`}
                  className="list-result-list-item__body__item__samples__sample"
                >
                  <div className="list-result-list-item__body__item__samples__sample__header">
                    <span>{analysisResult.name || analysisResult.type || '-'}</span>
                    <span
                      style={{
                        color: analysisResult.result?.toLowerCase() === 'positive'
                          ? theme.color.danger
                          : theme.color.success,
                      }}
                    >
                      {analysisResult.result || analysisResult.status || '-'}
                    </span>
                  </div>
                  <hr />
                  <div className="list-result-list-item__body__item__samples__sample__body">
                    <div className="list-result-list-item__body__item__samples__sample__body__item">
                      <p>Test date:</p>
                      <p>{formatDate(properties.processed || properties.record_time)}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export default ListResultListItem
